import Chart from "./Chart";
import TopNavBar from "./TopNavBar";
import RadarChart from "./RadarChart";
import DonutPieChart from "./DonutPieChart";
import PolarAreaChart from "./PolarAreaChart";

const Statistics = () => {
  return (
    <>
      <div className="min-h-full">
        <TopNavBar />
        <main>
          <div className="mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8">


            <div className="flex flex-col lg:flex-row lg:space-x-8 my-8">
              <div className="w-full lg:w-1/2">
                <RadarChart />
              </div>

              <div className="hidden lg:block w-px bg-gray-400"></div>              

              <div className="w-full lg:w-1/2">
                <Chart />
              </div>
            </div>


            <div className="inline-flex items-center justify-center w-full">
              <hr className="w-full h-2 my-8 bg-gray-400 border-0 rounded-sm dark:bg-gray-700"/>
              <div className="absolute px-1 -translate-x-1/2 bg-white left-1/2 dark:bg-gray-900">                    
                <svg width="40px" height="40px" viewBox="0 -1.5 2253 2253" style={{fillRule: "evenodd",clipRule: "evenodd",strokeLinecap: "round",strokeLinejoin: "round",strokeMiterlimit: 1.5}} version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                  <rect height="2250" width="2250" x="1.288" y="0" style={{ fill: "none" }}/>
                  <path d="M1147.12,208.333c-517.767,0 -937.5,419.733 -937.5,937.5c-0,428.307 290.275,802.155 705.228,908.271l232.272,-908.271l-0,-937.5Z" style={{ fill: "#3050f3", stroke: "#000000", strokeWidth: "66.67px" }}/>
                  <path d="M1996.79,749.576c-153.978,-330.174 -485.322,-541.243 -849.664,-541.243l-0,937.408l849.664,-396.165Z" style={{ fill: "#4dbe4b", stroke: "#000000", strokeWidth: "66.67px" }}/>
                  <path d="M904.478,2051.39c500.125,134.008 1014.19,-162.788 1148.2,-662.913c56.662,-211.462 37.532,-436.087 -54.072,-634.922l-851.483,392.279l-242.643,905.556Z" style={{ fill: "#308df8", stroke: "#000000", strokeWidth: "66.67px" }}/>
                </svg>
              </div>
            </div>
            
            
            <div className="flex flex-col lg:flex-row lg:space-x-8 my-8">
              <div className="w-full lg:w-1/2">
                <DonutPieChart/>
              </div>

              <div className="hidden lg:block w-px bg-gray-400"></div>

              <div className="w-full lg:w-1/2">
                <PolarAreaChart/>
              </div>
            </div>

          </div>
        </main>
      </div>        
    </>
  );
}   

export default Statistics;
